import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { addCompanyContact } from "../../../store/actions/Companies/companyActions";
import { debounce } from "../../../utils/debounce";
import { get } from "../../../services/api";
import { options } from "../../pages/WidgetBasic/ActiveUser";

const AddCompanyContact = forwardRef((props, ref) => {
  const [query, setQuery] = useState(""); // User's input
  const [results, setResults] = useState([]); // API results
  const [companyContactList, setCompanyContactList] = useState([]);

  const handleSuggestionClick = async (suggestion) => {
    const apiData = await fetch(
      `https://api.getaddress.io/${suggestion.url}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    // Destructure the API response
    const {
      line_1: addressLine1 = "",
      line_2: addressLine2 = "",
      town_or_city: town = "",
      county = "",
      country = "",
      postcode: postCode = "",
      region = "",
    } = result;

    // Update the form data with the new address details
    setFormData((prevFormData) => ({
      ...prevFormData,
      addressLine1,
      addressLine2,
      town,
      county,
      country,
      postCode,
      region,
    }));
    // setFormData({ ...formData, [field]: value });
    setResults([]); // Clear suggestions after selection
  };

  const fetchData = async (inputQuery) => {
    const apiData = await fetch(
      `https://api.getaddress.io/autocomplete/${inputQuery}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    setResults(result.suggestions);
  };

  // Handle input changes
  const handlePostCodeQueryChange = (inputQuery) => {
    setQuery(inputQuery); // Update input state
    debounce(fetchData(inputQuery)); // Call the debounced function
  };

  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    lastName: "",
    knownAs: "",
    comment: "",
    company: "",
    position: "",
    accountNumber: "",
    addressLine1: "",
    addressLine2: "",
    town: "",
    county: "",
    country: "",
    postCode: "",
    region: "",
    phone: "",
    phoneNumber: "",
    email: "",
    office: "",
    sector: "",
    personId: "",
    consultant: "",
    regDate: new Date(),
    source: "",
    statusDate: null,
    status: "PRE-REG",
    category: "",
    companyId: props?.companyId,
    currentPosition: "",
  });

  const resetForm = () => {
    setFormData({
      title: "",
      firstName: "",
      lastName: "",
      knownAs: "",
      comment: "",
      company: "",
      position: "",
      accountNumber: "",
      addressLine1: "",
      addressLine2: "",
      town: "",
      county: "",
      country: "",
      postCode: "",
      region: "",
      phone: "",
      phoneNumber: "",
      email: "",
      office: "",
      sector: "",
      personId: "",
      consultant: "",
      regDate: new Date(),
      source: "",
      statusDate: null,
      status: "PRE-REG",
      category: "",
      currentPosition: "",
      companyId: props?.companyId,
    });
    setErrors({});
  };
  useEffect(() => {
    if (!formData?.personId) {
      setPersonId();
    }
    if(props?.companyContacts) {
      setCompanyContactList(props?.companyContacts?.map((itm)=>itm.value))
    }
  }, [props?.companyContacts]);
  const setPersonId = async () => {
    const personId = await get(
      "/api/sequence/candidate-contact-person-id",
      props.token
    );
    setFormData({ ...formData, personId: personId.value });
  };
  const [errors, setErrors] = useState({});
  const [addContact, setAddContact] = useState(false);

  useImperativeHandle(ref, () => ({
    showContactModal() {
      if (!formData?.personId) {
        setPersonId();
      }
      setAddContact(true);
    },
  }));

  const nav = useNavigate();

  const validate = () => {
    const newErrors = {};

    // Required fields
    // const requiredFields = [
    //   "title",
    //   "firstName",
    //   "lastName",
    //   "postCode",
    //   "town",
    //   "country",
    //   "phone",
    //   "phoneNumber",
    // ];

    // requiredFields.forEach((field) => {
    //   if (!formData[field].trim()) {
    //     newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
    //   }
    // });

    // Email validation
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email must be valid.";
    }

    // Phone and Phone Number validation
    // if (!formData.phone) {
    //   newErrors.phone = "Phone type is required.";
    // }
    if (
      formData.phoneNumber && 
      !/^(?:\+44|0)\d{10}$/.test(formData.phoneNumber)
    ) {
      newErrors.phoneNumber = "Phone Number must be a valid UK mobile number.";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all the required fields.");
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    if (field === "postCode") {
      handlePostCodeQueryChange(value);
    }
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: "" }); // Clear specific field error
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const payload = {
        title: formData?.title,
        firstName: formData?.firstName,
        lastName: formData?.lastName,
        knownAs: formData?.knownAs,
        address: [
          {
            addressType: "HOME",
            isDefault: true,
            addressLine1: formData?.addressLine1,
            addressLine2: formData?.addressLine2,
            addressLine3: "",
            town: formData?.town,
            county: formData?.county,
            country: formData?.country,
            postcode: formData?.postCode,
            region: formData?.region,
          },
        ],
        contact: {
          phoneType: formData?.phone,
          phoneNumber: formData?.phoneNumber,
        },
        email: formData?.email?.toLowerCase(),
        website: "",
        business: "Rapid Resourcing Ltd",
        office: "Liverpool",
        sector: formData?.sector,
        personId: formData?.personId,
        consultant: formData?.consultant,
        regDate: formData?.regDate,
        source: formData?.source,
        statusDate: formData?.regDate,
        status: formData?.status,
        comment: formData?.comment,
        category: formData?.category,
        company: formData?.company,
        companyId: formData?.companyId,
        position: formData?.position,
        currentPosition: formData?.currentPosition,
        accountNumber: formData?.accountNumber,
      };
      dispatch(addCompanyContact(payload, setAddContact, props.token, resetForm));
    }
  };

  return (
    <>
      <Offcanvas
        show={addContact}
        onHide={() => {
          resetForm();
          setAddContact(false);
        }}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header">
          <h5 className="modal-title" id="#gridSystemModal">
            {props.Title}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              resetForm();
              setAddContact(false);
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="container-fluid">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {[
                  {
                    label: "Person ID",
                    field: "personId",
                    required: false,
                    disabled: true,
                  },
                  {
                    label: "Title",
                    field: "title",
                    type: "select",
                    required: false,
                    options: ["", "Mr.", "Mrs.", "Ms."],
                  },
                  { label: "First Name", field: "firstName", required: false },
                  { label: "Last Name", field: "lastName", required: false },
                  { label: "Known As", field: "knownAs", required: false },
                  { label: "Position", field: "currentPosition", required: false },
                  // { label: "Company", field: "company", required: false },
                  { label: "Contact Type", field: "position", required: false, type: "select", options: ["", ...companyContactList] },
                  // { label: "Category", field: "category", required: false },
                  // {
                  //   label: "Account Number",
                  //   field: "accountNumber",
                  //   required: false,
                  // },
                  { label: "Post Code", field: "postCode", required: false },
                  {
                    label: "Address Line 1",
                    field: "addressLine1",
                    required: false,
                  },
                  { label: "Address Line 2", field: "addressLine2" },
                  { label: "Town", field: "town", required: false },
                  { label: "County", field: "county"},
                  { label: "Country", field: "country", required: false },
                  // { label: "Region", field: "region", required: false },
                  {
                    label: "Phone Type",
                    field: "phone",
                    type: "select",
                    options: ["", "Home", "Mobile"],
                    required: false,
                  },
                  {
                    label: "Phone Number",
                    field: "phoneNumber",
                    required: false,
                  },
                  {
                    label: "Email",
                    field: "email",
                    type: "email",
                    required: false,
                  },
                  // { label: "Office", field: "office", required: false },
                  // { label: "Sector", field: "sector", required: false },
                  // { label: "Source", field: "source", required: false },
                ].map(
                  ({
                    label,
                    field,
                    type = "text",
                    required = false,
                    options = [],
                    disabled = false,
                  }) => (
                    <div className="col-xl-6 mb-3" key={field}>
                      {type === "select" ? (
                        <>
                          <label className="form-label">
                            {label}{" "}
                            {required && <span className="text-danger">*</span>}
                          </label>
                          <select
                            className="form-control"
                            value={formData[field]}
                            disabled={disabled}
                            onChange={(e) =>
                              handleInputChange(field, e.target.value)
                            }
                          >
                            {options?.map((itm) => (
                              <option value={itm}>{itm}</option>
                            ))}
                          </select>
                        </>
                      ) : (
                        <>
                          <label className="form-label">
                            {label}{" "}
                            {required && <span className="text-danger">*</span>}
                          </label>
                          <input
                            type={type}
                            className="form-control"
                            value={formData[field]}
                            disabled={disabled}
                            onChange={(e) =>
                              handleInputChange(field, e.target.value)
                            }
                          />
                          {field === "postCode" && results?.length > 0 && (
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                maxHeight: "150px", // Medium size scrollable div
                                overflowY: "auto",
                                marginTop: "5px",
                                padding: "10px",
                                backgroundColor: "#fff",
                              }}
                            >
                              {results?.map((suggestion, index) => (
                                <div
                                  key={index}
                                  style={{
                                    padding: "5px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #eee",
                                  }}
                                  onClick={() =>
                                    handleSuggestionClick(suggestion)
                                  } // Handle click on suggestion
                                >
                                  {suggestion.address}
                                </div>
                              ))}
                            </div>
                          )}
                        </>
                      )}

                      {errors[field] && (
                        <small className="text-danger">{errors[field]}</small>
                      )}
                    </div>
                  )
                )}
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Registration Date</label>
                  <br />
                  <DatePicker
                    className="form-control"
                    selected={formData.regDate}
                    onChange={(date) => handleInputChange("regDate", date)}
                    dateFormat="dd/MM/yyyy"
                  />
                  {errors.regDate && (
                    <small className="text-danger">{errors.regDate}</small>
                  )}
                </div>
                {/* <div className="col-xl-6 mb-3">
                  <label className="form-label">Status Date</label>
                  <br />
                  <DatePicker
                    className="form-control"
                    selected={formData.statusDate}
                    onChange={(date) => handleInputChange("statusDate", date)}
                  />
                  {errors.statusDate && (
                    <small className="text-danger">{errors.statusDate}</small>
                  )}
                </div> */}
                {/* <div className="col-xl-6 mb-3">
                  <label className="form-label">Status</label>
                  <select
                    className="default-select form-control"
                    value={formData.status}
                    onChange={(e) =>
                      handleInputChange("status", e.target.value)
                    }
                  >
                    <option value="PRE-REG" selected>
                      PRE-REG
                    </option>
                    <option value="LIVE">LIVE</option>
                    <option value="ARCHIVED">ARCHIVED</option>
                    <option value="GDPR REMOVED">GDPR REMOVED</option>
                    <option value="PLACED">PLACED</option>
                    <option value="NOT LOOKING FOR WORK">
                      NOT LOOKING FOR WORK
                    </option>
                  </select>
                </div> */}
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Comment </label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.comment}
                    onChange={(e) =>
                      handleInputChange("comment", e.target.value)
                    }
                  />
                </div>
              </div>
              <div>
                <button type="submit" className="btn btn-primary me-1">
                  Submit
                </button>
                <Link
                  to={"#"}
                  onClick={() => {
                    resetForm();
                    setAddContact(false);
                  }}
                  className="btn btn-danger light ms-1"
                >
                  Cancel
                </Link>
              </div>
            </form>
          </div>
        </div>
      </Offcanvas>
    </>
  );
});

export default AddCompanyContact;
